module.exports = __webpack_public_path__ + "static/media/Introduction to School Management system.c77c09fe.png";